import React, { PureComponent } from 'react';

/**
 * Higher Order Component which wraps the modal state on the wrapped component
 * @param {*} WrappedComponent - whatever the component we wrap with withModal
 */

function withModal(WrappedComponent) {
  return class WithModal extends PureComponent {
    /**
     * Constructor
     */
    constructor(props) {
      super(props);
      this.state = {
        // eslint-disable-next-line react/no-unused-state
        open: false,
      };

      this.toggleModal = this.toggleModal.bind(this);
    }

    /**
     * Sets the state for the modal
     */
    toggleModal() {
      const { modalOpen } = this.state;

      this.setState({
        modalOpen: !modalOpen,
      });
    }

    /**
     * Render
     */
    render() {
      const { modalOpen } = this.state;
      return <WrappedComponent modalOpen={modalOpen} toggleModal={this.toggleModal} {...this.props} />;
    }
  };
}

export default withModal;
